import { gql } from '@apollo/client';
import {
  CHILD_PROFILE_FIELDS,
  ROADMAP_FIELDS,
  ROADMAP_TOY_FIELDS,
} from './Fragments';

export const ULTRA_PLAN_SUBSCRIBERS = gql`
  query UltraPlanSubscribers(
    $filter: UltraPlanSubscribersFilter
    $sort: UltraPlanSubscribersSort
  ) {
    ultraPlanSubscribers(filter: $filter, sort: $sort) {
      count
      data {
        id
        subscriptionId
        status
        startedAt
        expireAt
        user {
          id
          userNumber
          firstName
          lastName
          email
          contactNo
          pincode {
            library {
              id
              name
              libraryNumber
            }
          }
          userLibraries {
            id
            type
            library {
              id
              name
              libraryNumber
            }
          }
        }
        subscriptionPlan {
          id
          name
          type
          slug
        }
        metaData {
          ultraPlanRoadMap
        }
        roadmapSelections {
          id
          weekNumber
          slotPosition
          slotKey
          toyId
        }
      }
    }
  }
`;

export const ULTRA_PLAN_SUBSCRIPTION_ADMIN = gql`
  query UltraPlanSubscriptionAdmin($where: UserUniqueInput!) {
    userSubscriptionAdmin(where: $where) {
      data {
        id
        subscriptionId
        status
        startedAt
        expireAt
        planDurationWeeks
        subscriptionFeatures {
          maxBigToyAllowed
          totalKeepCountPerMonth
        }
        user {
          id
          userNumber
          firstName
          lastName
          email
          contactNo
        }
        subscriptionPlan {
          id
          name
          type
          slug
        }
        metaData {
          ultraPlanRoadMap
        }
      }
    }
  }
`;

export const ULTRA_PLAN_SUBSCRIBER_CHILD_PROFILES = gql`
  query UltraPlanSubscriberChildProfiles(
    $data: UltraPlanSubscriberChildProfilesInput!
  ) {
    ultraPlanSubscriberChildProfiles(data: $data) {
      count
      data {
        ${CHILD_PROFILE_FIELDS}
      }
    }
  }
`;

export const ULTRA_PLAN_ROADMAP = gql`
  query UltraPlanRoadmap($data: UltraPlanRoadmapInput!) {
    ultraPlanRoadmap(data: $data) {
      data {
        ${ROADMAP_FIELDS}
      }
    }
  }
`;

export const ULTRA_PLAN_ROADMAP_SIGNED_PUT_URL = gql`
  query GetUltraPlanRoadMapSignedPutUrl(
    $data: GetUltraPlanRoadMapSignedPutUrlInput!
  ) {
    getUltraPlanRoadMapSignedPutUrl(data: $data) {
      signedUrl
      fileName
    }
  }
`;

export const SWAP_SUGGEST_TOYS_ADMIN = gql`
  query SwapSuggestToysAdmin(
    $where: SwapSuggestToysAdminWhereInput!
    $filter: SwapSuggestToysFilter
  ) {
    swapSuggestToysAdmin(where: $where, filter: $filter) {
      count
      data {
        id
        toy {
          ${ROADMAP_TOY_FIELDS}
        }
      }
    }
  }
`;

export const ROADMAP_TOY_SWAP_SUGGESTIONS_ADMIN = gql`
  query RoadmapToySwapSuggestionsAdmin(
    $filter: RoadmapToySwapSuggestionsAdminFilter
  ) {
    roadmapToySwapSuggestionsAdmin(filter: $filter) {
      count
      data {
        id
        weekNumber
        status
        note
        createdAt
        suggestedToy {
          ${ROADMAP_TOY_FIELDS}
        }
        roadmapSlot {
          id
        }
      }
    }
  }
`;
